export const ingoreReduxNames = {
  env: 'env',
  element: 'element',
  e: 'e',
};

export const ingoreTextMarkdownName = ['e', 'element'];
